import React from 'react';
import AppContext from '../../../contexts/AppContext';
import { TabContent, TabPane, Nav, NavItem, NavLink, Card, Button, CardTitle, CardText, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import WriterForm from './WriterForm';
import EmployerForm from './EmployerForm';
import './RegisterTab.css';

export class RegisterTab extends React.Component {
    state = {
        currentTab :'1',
        activeTab:'1'
    };
    constructor(props) {
        super(props);

        this.toggle = this.toggle.bind(this);
        const nextRoute = new URLSearchParams(window.location.search); 
        if(nextRoute.get('tab') == 'writer'){
            console.log("Before", this.state)
            this.state.currentTab = '2';
            this.state.activeTab = '2';
            console.log("after",this.state)
            this.props.parentCallback('2');
        }else{
            this.state.currentTab = '1';
            this.state.activeTab = '1';
            this.props.parentCallback('1');
        } 
    }

    toggle(tab) {
        this.state.currentTab = tab;
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
        this.props.parentCallback(tab);
    }
    
    render() {
        return (
            <div className="register-tab-container pt-4">
                <Nav tabs className="signup-tabs">
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '1' })}
                            onClick={() => { this.toggle('1'); }}
                        >
                            <div className="register-tab-inner">
                                <div className="icon-wrapper">
                                  <img src="/images/ProWriter_EmployerIcon.png" alt="" />
                                </div>
                                <span>I'm an Employer</span>
                            </div>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({ active: this.state.activeTab === '2' })}
                            onClick={() => { this.toggle('2'); }}
                        >
                            <div className="register-tab-inner">
                                <div className="icon-wrapper">
                                 <img src="/images/ProWriter_WriterIcon.png" alt="" />
                                </div>
                                <span>I'm a Writer</span>
                            </div>
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="1">
                      { this.state.currentTab =='1' ?<EmployerForm  /> :''}
                    </TabPane>
                    <TabPane tabId="2">
                    { this.state.currentTab =='2' ? <WriterForm  localtionPath={this.props.localtionPath}/> : '' }
                    </TabPane>
                </TabContent>
            </div>
        );
    }
}
RegisterTab.contextType = AppContext;
export default RegisterTab;


// WEBPACK FOOTER //
// ./src/components/auth/register/RegisterTab.js